module.exports = __webpack_public_path__ + "img/section2Bg2M.9fc35c11.webp";